import React from "react";
import { Space } from "antd";
import { AxTooltip, AxButton, AxDivider } from "@dynata/axiom3";

class Tooltip extends React.Component {
  render() {
    return (
      <div className="section" id="tooltip">
        <h3>Tooltip</h3>
        <p>A simple text popup tip.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxTooltip content="Tooltip content">
  ...
</AxTooltip>`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/tooltip/#API"
                >
                  https://ant.design/components/tooltip/#API
                </AxButton>
              </p>
            </div>
            <table className="props-table">
              <tbody>
                <tr>
                  <th>Property</th>
                  <th>Value</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>content</td>
                  <td>string</td>
                  <td>Tooltip content</td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/popover/#API"
                      >
                        {`<Popover />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <pre>{`<AxTooltip content="Tooltip content">
  <AxButton type="secondary">Tooltip</AxButton>
</AxTooltip>`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Example
        </AxDivider>
        <Space>
          <AxTooltip content="Tooltip content">
            <AxButton type="secondary">Tooltip</AxButton>
          </AxTooltip>
        </Space>
      </div>
    );
  }
}
export default Tooltip;
